import { Router } from '@angular/router';
import { of } from 'rxjs';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AlertService } from '../services/alert.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const alertService = inject(AlertService)

    if (!authService.isValidToken()) {
        router.navigate(['/home']);
        return of(false);
    }

    const expectedRole = route.data['roles'];

    if(expectedRole){
        const roleId = authService.getUserRoleId();
  
        if (!expectedRole?.includes(roleId)) {
          alertService.showErrorAlert('','Usted no tiene acceso al módulo seleccionado');
          router.navigate(['/home']);
          return of(false);
        }
      }

    return of(true);
};